import { render, staticRenderFns } from "./BookingDetails.vue?vue&type=template&id=0373fe76&scoped=true&"
import script from "./BookingDetails.vue?vue&type=script&lang=js&"
export * from "./BookingDetails.vue?vue&type=script&lang=js&"
import style0 from "./BookingDetails.vue?vue&type=style&index=0&id=0373fe76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0373fe76",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCheckbox,VCol,VIcon,VRow})
